import './title6.css'
export default function Title6(){
    return(
        <>
       <div className="h"> <div className="head-6">
       </div></div>
        <div className="t">
        <h3 className='t-1'>Food Solutions and Technology Products</h3>
        </div>
        </>
    )
}